<div *ngIf="users.length === 0 && !isLoading">
  <img class="no-data" src="../../../assets/images/empty-box-icon.png" />
  <p class="text-center">No Data</p>
</div>

<div
  *ngIf="!isLoading"
  class="container users table-responsive overflow-y-hidden"
>
  <table *ngIf="users.length > 0" class="users-table">
    <thead>
      <tr>
        <th class="th-users width-300">Display Name</th>
        <th class="th-users width-350">Object ID</th>
        <th class="th-users width-300">Email</th>
        <th class="th-users">Mobile Phone</th>
        <th class="th-users">Role Name</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users; let i = index" class="body-tr">
        <td class="td-users" (click)="selectUser(user)">
          <img
            *ngIf="user.photo != null"
            class="profile-image"
            src="{{ user.photo }}"
          />
          <img
            *ngIf="user.photo == null"
            class="profile-image"
            src="../../../assets/images/user-not-found-icon.png"
          />
          <span class="cut-text ms-5 mt-1" title="{{ user.displayName }}">
            {{ user.displayName }}</span
          >
        </td>
        <td
          *ngIf="user.id != null"
          class="td-users"
          title="{{ user.id }}"
          style="display: flex; direction: row"
        >
          <label id="object-id-{{ i }}">{{ user.id }} </label>
          <img
            ngxClipboard
            class="file"
            src="../../../assets/images/copy-to-clipboard.png"
            [cbContent]="user.id"
            title="Copy to Clipboard"
            (click)="setItalic(i)"
          />
        </td>
        <td *ngIf="user.id == null" class="td-users align-top">unknown</td>
        <td class="td-users align-top" title="{{ user.mail }}">
          {{ user.mail }}
        </td>
        <td
          class="td-users"
          *ngIf="user.mobilePhone != null"
          title="{{ user.mobilePhone }}"
        >
          <span class="cut-mobile-phone"> {{ user.mobilePhone }}</span>
        </td>
        <td class="td-users align-top" *ngIf="user.mobilePhone == null">
          unknown
        </td>
        <td class="td-users align-top">
          {{ getCustomAttributes(user) }}
        </td>
      </tr>
    </tbody>
  </table>
  <div
    *ngIf="isLoadingMoreData"
    class="loading-more-data d-flex justify-content-center mt-3"
  ></div>
</div>
<div *ngIf="isLoading" class="loading"></div>

<!--User Details Modal start-->
<button
  type="button"
  class="btn btn-primary"
  data-bs-toggle="modal"
  data-bs-target="#details"
  [hidden]="true"
  id="openModalButton"
>
  Open Modal
</button>
<div
  class="modal fade"
  id="details"
  tabindex="-1"
  aria-labelledby="detailsLabel"
  aria-hidden="true"
>
  <app-user-details-modal
    [selectedUser]="selectedUser"
  ></app-user-details-modal>
</div>
<!--User Details Modal end-->

<!--Confirmation Modal start-->
<button
  type="button"
  class="btn btn-primary"
  data-bs-toggle="modal"
  data-bs-target="#confiramtion"
  [hidden]="true"
  id="openConfirmationModalButton"
>
  Open Modal
</button>
<div
  class="modal fade"
  id="confiramtion"
  tabindex="-1"
  aria-labelledby="confiramtionLabel"
  aria-hidden="true"
>
  <app-delete-user-confirmation-modal
    [selectedUser]="selectedUser"
    [users]="users"
  ></app-delete-user-confirmation-modal>
</div>
<!--Confirmation Modal end-->
